import PropTypes from "prop-types";
import { ColumnGroup, Column } from "@/base/Column";

const MultiColumnBlade = ({ column_one, column_two, column_three, original }) => {

  const columns = [column_one, column_two, column_three];

  let flexWrapper = columns.find(col => col?.flex_card)

  let originalColumns = original.filter((el) => el.name === 'column');


  const getColumns = () => {
    return columns.map((column, columnIndex) => {
      let columnElements = originalColumns[columnIndex]
      return column ? <Column key={column.id} column={column} original={columnElements} columnCount={columns.length} /> : null
    })
  }

  return (
    <ColumnGroup fullWidth={!!flexWrapper}>
      {getColumns()}
    </ColumnGroup>
  );
};

MultiColumnBlade.defaultProps = {
  stylesOverride: {}
};

MultiColumnBlade.propTypes = {
  column_one: PropTypes.object.isRequired,
  column_two: PropTypes.object.isRequired,
  column_three: PropTypes.object,
  stylesOverride: PropTypes.object,
  original: PropTypes.array
};

export default MultiColumnBlade;
